import { combineReducers } from "redux";

import authReducer, { IAuthState } from "./modules/auth/reducer";
import routerReducer, { IRouterState } from "./modules/router/reducer";
import flightMarkersReducer, {
  IFlightMarkersState,
} from "./modules/flightMarkers/flightMarkersReducer";
import siteReducer, { ISiteState } from "./modules/site/reducer";
import prescanReducer, { IPrescanState } from "./modules/prescan/reducer";

import lastDispatchedActionReducer from "./modules/lastDispatchedAction";
import deprecatedUiReducer, { IDeprecatedUIState } from "./modules/ui/reducer";

import gcpRequestReducer, {
  IGCPRequestState,
} from "./modules/gcpRequest/reducer";
import initalGCPRequestReducer, {
  IInitialGCPRequestState,
} from "./modules/initialGCPRequest/initialGcpRequestReducer";
import geolocationReducer, {
  IGeolocationState,
} from "./modules/geolocation/reducer";
import worldLayerReducer, {
  IWorldLayerState,
} from "./modules/worldLayer/reducer";
import modeReadonlyUiReducer, {
  IModeReadonlyUi,
} from "./modules/modeReadonlyUi/reducer";
import modeAddUiReducer, { IModeAddUi } from "./modules/modeAddUi/reducer";
import fakeGcpsReducer, { IFakeGcpsState } from "./modules/fakeGcps/reducer";
import fatalErrorReducer, {
  IFatalErrorState,
} from "./modules/fatalError/reducer";
import modeGcpRequestReducer, {
  IModeGcpRequestUi,
} from "./modules/modeGcpRequestUi/reducer";
import anyScanReducer, { IAnyScanState } from "./modules/anyScan/reducer";
import modePilotUiReducer, {
  IModePilotUi,
} from "./modules/modePilotUi/reducer";

export interface IStoreState {
  anyScan: IAnyScanState;
  auth: IAuthState;
  deprecatedUi: IDeprecatedUIState;
  fakeGcps: IFakeGcpsState;
  fatalError: IFatalErrorState;
  gcpRequest: IGCPRequestState;
  geolocation: IGeolocationState;
  initialGCPRequest: IInitialGCPRequestState;
  modeAddUi: IModeAddUi;
  modeGcpRequestUi: IModeGcpRequestUi;
  modePilotUi: IModePilotUi;
  modeReadonlyUi: IModeReadonlyUi;
  nails: IFlightMarkersState;
  prescan: IPrescanState;
  router: IRouterState;
  site: ISiteState;
  worldLayer: IWorldLayerState;
}

export const getAuthState = (state: IStoreState): IAuthState => state.auth;
export const getRouterState = (state: IStoreState): IRouterState =>
  state.router;
export const getDeprecatedUIState = (state: IStoreState): IDeprecatedUIState =>
  state.deprecatedUi;
export const getFlightMarkersState = (
  state: IStoreState,
): IFlightMarkersState => state.nails;
export const getFakeGcpsState = (state: IStoreState): IFakeGcpsState =>
  state.fakeGcps;
export const getSiteState = (state: IStoreState): ISiteState => state.site;
export const getAnyScanState = (state: IStoreState): IAnyScanState =>
  state.anyScan;
export const getPrescanState = (state: IStoreState): IPrescanState =>
  state.prescan;
export const getGCPRequestState = (state: IStoreState): IGCPRequestState =>
  state.gcpRequest;
export const getInitialGCPRequestState = (
  state: IStoreState,
): IInitialGCPRequestState => state.initialGCPRequest;
export const getGeolocationState = (state: IStoreState): IGeolocationState =>
  state.geolocation;
export const getModeAddUiState = (state: IStoreState): IModeAddUi =>
  state.modeAddUi;
export const getModeGcpRequestUiState = (
  state: IStoreState,
): IModeGcpRequestUi => state.modeGcpRequestUi;
export const getWorldLayerState = (state: IStoreState): IWorldLayerState =>
  state.worldLayer;
export const getModeReadonlyUiState = (state: IStoreState): IModeReadonlyUi =>
  state.modeReadonlyUi;
export const getFatalErrorState = (state: IStoreState): IFatalErrorState =>
  state.fatalError;
export const getModePilotUiState = (state: IStoreState): IModePilotUi =>
  state.modePilotUi;

export default combineReducers({
  auth: authReducer,
  router: routerReducer,
  prescan: prescanReducer,
  anyScan: anyScanReducer,
  site: siteReducer,
  deprecatedUi: deprecatedUiReducer,
  nails: flightMarkersReducer,
  fakeGcps: fakeGcpsReducer,
  lastDispatchedAction: lastDispatchedActionReducer,
  gcpRequest: gcpRequestReducer,
  initialGCPRequest: initalGCPRequestReducer,
  geolocation: geolocationReducer,
  modeAddUi: modeAddUiReducer,
  modeGcpRequestUi: modeGcpRequestReducer,
  worldLayer: worldLayerReducer,
  modeReadonlyUi: modeReadonlyUiReducer,
  fatalError: fatalErrorReducer,
  modePilotUi: modePilotUiReducer,
});
